export const CONTENT_WIDTH = "1180px";
